import React from 'react';
import _ from 'lodash';

import Conditional from '../../../common/conditional';
import PDFPage from '../../../themed/pdf/pdfPage';
import VTPipingAnomaly from '../vt/vtPipingAnomaly';
import RiskRating from '../riskRating';

import config from '../../../../utils/config';

import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';

interface ETAnomalyPDFProps {
	data: any[];
	project: models.Project;
}

const ETAnomalyPDF = (props: ETAnomalyPDFProps) => {
	return (
		<React.Fragment>
			{_.chunk(props.data, 3).map((items, i: number) => (
				<PDFPage
					key={i.toString()}
					pageDetails={utils.getPageDetails('Anomaly Report')}
					projectDetails={props.project}
					enableTitlePage={i === 0}
				>
					<VTPipingAnomaly vtPipingReportSummary="" data={items} />
				</PDFPage>
			))}

			<Conditional isVisible={config.enableRiskRating}>
				<PDFPage
					pageDetails={utils.getPageDetails('Risk Rating')}
					projectDetails={props.project}
				>
					<Conditional isVisible={props.data.length > 0}>
						<RiskRating data={props.data} />
					</Conditional>
				</PDFPage>
			</Conditional>
		</React.Fragment>
	);
};

export default ETAnomalyPDF;
